<template>
<Layout>
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card bg-pattern">
                <div class="card-body p-4">
                    <div class="text-center">
                    <img src="@/assets/logo-vertical.png" alt height="150" />
                    </div>
                    <br>
                    <form v-if="CountDown != '0'" action="" class="form-box" @submit.prevent="validateForm" novalidate>
                        <FormInput
                            name="Password"
                            type="password"
                            label="รหัสผ่าน"
                            v-model="values.Password"
                            placeholder="รหัสผ่าน"
                            :require-field="true"
                            @validate="validate"
                            formGroupClass="form-group"
                            :error="errors.Password"
                        />
                        <FormInput
                            name="ConfirmPassword"
                            type="password"
                            label="ยืนยันรหัสผ่าน"
                            v-model="values.ConfirmPassword"
                            placeholder="ยืนยันรหัสผ่าน"
                            :require-field="true"
                            @validate="validate"
                            formGroupClass="form-group"
                            :error="errors.ConfirmPassword"
                        />
                        <div class="text-center mt-3">
                            <button type="submit" class="btn btn-primary d-flex m-auto align-items-center">
                                <div>ตั้งรหัสผ่าน</div>
                                <div v-show="IsSubmit" class="spinner-border spinner-border-sm ml-2" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </button>
                        </div>
                    </form>
                    <div v-else class="form-box text-center">
                        <h4 class="red">ลิงค์ขอเปลี่ยนรหัสผ่านหมดอายุแล้ว</h4>
                        <div>
                            กรุณา <router-link :to="{name: 'forgetpassword' }">คลิกที่นี่</router-link> ทำรายการใหม่อีกครั้ง
                        </div>
                    </div>
                    <section class="text-center mt-4 pb-2">
                        <h5>กลับไปหน้าเข้าสู่ระบบ ?</h5>
                        <div>
                            <router-link :to="{name: 'login' }">ล็อกอินเพื่อเข้าสู่ระบบที่นี่</router-link>
                            <br>
                        </div>
                    </section>
                </div>
                <!-- end card-body -->
                </div>
                <!-- end card -->
                <!-- end row -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>

<script>
    import Layout from '@/components/layouts/auth'
    export default {
        name: 'ResetPassword',
        components: { Layout },
        data() {
            var yup = this.yup
            return {
                step: 1,
                webUrl: process.env.VUE_APP_WEB_URL,
                IsSubmit: false,
                values: {
                    RefId: "",
                    Password: "",
                    ConfirmPassword: "",
                },
                errors: {
                    RefId: "",
                    Password: "",
                    ConfirmPassword: "",
                },
                FormSchema: yup.object().shape({
                    Password: yup.string().min(8).required('กรุณากรอกรหัสผ่าน'),
                    ConfirmPassword: yup.string()
                        .required('กรุณายืนยันรหัสผ่านอีกครั้ง')
                        .oneOf([yup.ref("Password")], "รหัสผ่านไม่เหมือนกัน"),
                }),
                Timer: '',
                ExpiredAt: '',
                CountDown: 0,
            };
        },
        mounted(){
            let self = this;
            this.$store.commit('setSubMenu',0);
            this.values.RefId = this.$route.query.refid;
            if(this.values.RefId != '')
            {
                this.axios.get(process.env.VUE_APP_OFFICEAPI_URL+'/api/resetpassword', {
                    params: {
                        RefId: this.values.RefId,
                    }
                })
                .then(function (res) {
                    if(res.status == 200){
                        if(res.data.RefId){
                            self.Ref = res.data.Ref;
                            self.ExpiredAt = res.data.ExpiredAt;
                            self.Timer = setInterval(self.thisSetCountDown, 100)
                        }
                    }else{
                        self.$swal('เกิดข้อผิดพลาด');
                    }
                })
                .catch(function (error) {
                    self.$swal('เกิดข้อผิดพลาด');
                });
            }
        },
        methods: {
            validateForm() {
                this.FormSchema
                .validate(this.values, { abortEarly: false })
                .then(() => {
                    console.log(this.values)
                    this.sendData(this.values);
                })
                .catch(err => {
                    err.inner.forEach(error => {
                        this.errors = { ...this.errors, [error.path]: error.message };
                    });
                });
            },
            validate(field) {
                this.FormSchema
                .validateAt(field, this.values)
                .then(() => {
                    this.errors[field] = "";
                })
                .catch(err => {
                    this.errors[err.path] = err.message;
                });
            },
            sendData(values){
                let self = this;
                this.IsSubmit = true;
                this.axios.put(process.env.VUE_APP_OFFICEAPI_URL+'/api/admin/resetpassword',values)
                .then(function (res) {
                    if(res.status == 200){
                        self.$swal.fire({
                            icon: 'success',
                            title: 'เปลี่ยนรหัสผ่าน',
                            text: 'เปลี่ยนรหัสผ่านสำเร็จ กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
                            showCancelButton: false,
                            confirmButtonText: 'ตกลง',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                self.$router.push({ name: 'login' })
                            } 
                        })
                    }else{
                        self.$swal('เกิดข้อผิดพลาด');
                    }
                    self.IsSubmit = false;
                })
                .catch(function (error) {
                    self.$swal('เกิดข้อผิดพลาด');
                    self.IsSubmit = false;
                    console.log(error);
                });
            },
            setCountDown(datetime){
                let diff = this.$dayjs(datetime).diff(this.$dayjs())
                let time = ''
                if(diff > 0){
                    let d = Math.trunc(diff / 1000 / 3600 / 24);
                    let h = Math.trunc(diff / 1000 / 3600) % 24;
                    let m = Math.trunc(diff / 1000 / 60) % 60;
                    let s = Math.trunc(diff / 1000) % 60
                    time = `${(m > 9?m:'0'+m)}:${(s > 9?s:'0'+s)}`
                }else{
                    time = '0'
                }
                return time
            },
            thisSetCountDown(){
                this.CountDown = this.setCountDown(this.ExpiredAt)
            }
        },
        beforeDestroy () {
            clearInterval(this.Timer)
        }
    }
</script>
